/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  postActivoAmortizacionContabilizar,
  postActivoAmortizacionDescontabilizar,
  postActivoAmortizaciones,
} from "api/Activo.service"
import { GetAmortizacionesDtoPropsProps } from "api/DTOs/GetAmortizacionesDto"
import notification from "common/utils/notification"
import { TFunction } from "i18next"
import { InputSwitch } from "primereact/inputswitch"
import { frontendCurrency } from "utils/formatCurrency"
import { frontendDateFormat } from "utils/formatDate"

export const ACTIVOID_COLUMNS = (
  t: TFunction,
  fetchTableData: () => void,
  activoId?: string
) => {
  const columns = [
    {
      key: "periodo",
      header: `${t("nsAssets.amortizedTable.period")}`,
      field: "periodo",
      style: { width: "15%" },
      body: ({ fechaUltimaAmortizacion }: GetAmortizacionesDtoPropsProps) =>
        fechaUltimaAmortizacion
          ? new Date(fechaUltimaAmortizacion).getFullYear()
          : null,
    },
    {
      key: "fechaUltimaAmortizacion",
      header: `${t("nsAssets.amortizedTable.lastAmortizationDate")}`,
      field: "fechaUltimaAmortizacion",
      style: { width: "20%" },
      body: ({ fechaUltimaAmortizacion }: GetAmortizacionesDtoPropsProps) =>
        fechaUltimaAmortizacion
          ? frontendDateFormat(new Date(fechaUltimaAmortizacion))
          : null,
    },
    {
      key: "CuotaAmortizacion",
      header: `${t("nsAssets.amortizedTable.amortizationFee")}`,
      field: "cuotaAmortizacion",
      bodyClassName: "!tw-text-end",
      alignCol: "right",
      style: { width: "20%" },
      body: ({ cuotaAmortizacion }: GetAmortizacionesDtoPropsProps) =>
        cuotaAmortizacion ? frontendCurrency(cuotaAmortizacion) : null,
    },
    {
      key: "ValorNetoActual",
      header: `${t("nsAssets.amortizedTable.currentNetValue")}`,
      field: "valorNetoActual",
      style: { width: "20%" },
      bodyClassName: "!tw-text-end",
      alignCol: "right",
      body: ({ valorNetoActual }: GetAmortizacionesDtoPropsProps) =>
        valorNetoActual ? frontendCurrency(valorNetoActual) : null,
    },
    {
      key: "AmortizacionAcumulada",
      header: `${t("nsAssets.amortizedTable.accumulatedAmortization")}`,
      field: "amortizacionAcumulada",
      bodyClassName: "!tw-text-end",
      alignCol: "right",
      style: { width: "20%" },
      body: ({ amortizacionAcumulada }: GetAmortizacionesDtoPropsProps) =>
        amortizacionAcumulada ? frontendCurrency(amortizacionAcumulada) : null,
    },
    {
      key: "Asiento",
      header: `${t("nsAssets.amortizedTable.entry")}`,
      field: "asiento",
      style: { width: "5%" },
      alignCol: "right",
      className: "!tw-p-2",
      headClassName: "!tw-p-2",
      bodyClassName: "!tw-w-auto tw-flex tw-justify-end !tw-text-end",
      body: (rowData: GetAmortizacionesDtoPropsProps) => {
        return (
          <InputSwitch
            checked={Boolean(rowData.asientoId)}
            className='tw-h-fit'
            onChange={async () => {
              const params: postActivoAmortizaciones = {
                id: activoId,
                amortizacionId: rowData.id,
              }
              try {
                if (rowData.asientoId) {
                  await postActivoAmortizacionDescontabilizar(params).then(() =>
                    notification.success()
                  )
                } else {
                  await postActivoAmortizacionContabilizar(params).then(() =>
                    notification.success()
                  )
                }
                fetchTableData()
              } catch (error) {
                // eslint-disable-next-line no-console
                console.error(error)
              }
            }}
          />
        )
      },
    },
  ]
  return columns
}
